import { pxToRem } from '../../../../utils';
export var chatMessageDetailsVariables = function chatMessageDetailsVariables(siteVars) {
  return {
    detailsColor: siteVars.colorScheme.default.foreground1,
    detailsFontSize: siteVars.fontSizes.small,
    detailsMargin: pxToRem(12)
  };
};